import TopBar from './TopBar';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../common/ScrollToTop';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="site-wrapper">
      <TopBar />
      <Header />
      <main className="site-main">
        {children}
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Layout;
